import { render } from "./LoadingSpinner.vue?vue&type=template&id=18bfbe48&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=18bfbe48&scoped=true&lang=scss"

import exportComponent from "D:\\repos\\multihabit-webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bfbe48"]])

export default __exports__